import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { orgActions } from "../../actions";

function IngestorDashboard(props) {
  const { org, getOcrInfo, getScrapeInfo } = props;
  const current_org_id = Number(org.current_org_id);
  const ocr_info = org.ocr_info;
  const scrape_info = org.scrape_info;

  const total_file_count = scrape_info?.s3_file_count;
  const rendered_file_count = scrape_info?.db_file_count;
  const unrendered_file_count =
    scrape_info?.s3_file_count - scrape_info?.db_file_count;

  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      getScrapeInfo(current_org_id);
      getOcrInfo(current_org_id);
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      total jackets:&nbsp;{total_file_count - 1}
      <br />
      unrendered jackets:&nbsp;{unrendered_file_count - 1}
      <br />
      rendered jackets:&nbsp;{rendered_file_count}
      <br />
      pages pending ocr:&nbsp;{ocr_info?.undispatched_pages}
      <br />
      pages sent for ocr:&nbsp;{ocr_info?.azure_pending_pages}
      <br />
      pages retrieved from ocr:&nbsp;{ocr_info?.azure_pages}
      <br />
    </>
  );
}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org,
  };
}

const actionCreators = {
  getOcrInfo: orgActions.getOcrInfo,
  getScrapeInfo: orgActions.getScrapeInfo,
};

const connectedIngestorDashboard = connect(
  mapStateToProps,
  actionCreators
)(IngestorDashboard);
export { connectedIngestorDashboard as IngestorDashboard };
